import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const BreadcrumbList = forwardRef<
  HTMLOListElement,
  React.ComponentPropsWithoutRef<"ol">
>(function BreadcrumbList({ className, ...props }, ref) {
  return (
    <ol
      ref={ref}
      className={classNames(
        "flex items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-3 overflow-hidden",
        className,
      )}
      {...props}
    />
  );
});
